import { render } from "./whats-app-preview.vue?vue&type=template&id=bfe151d0&scoped=true"
import script from "./whats-app-preview.vue?vue&type=script&lang=js"
export * from "./whats-app-preview.vue?vue&type=script&lang=js"

import "./whats-app-preview.vue?vue&type=style&index=0&id=bfe151d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe151d0"]])

export default __exports__